import type {
  HoverIdleSettingsState,
  MHovAnimationSpeed,
  MHovChargeDurationMs,
  NHovAnimationSpeed,
  NHovChargeDurationMs,
  OHovChargeDurationMs,
} from "../types";

// Outside-family reset burst playback mode. "off" suppresses the Outside Burst
// effect entirely; "full" plays the full CSS animation.
export type OutsideResetBurstAnimationMode = "full" | "off";

export interface HoverIdleMotionPolicy {
  readonly hovCellHoverPulse: boolean;
  readonly upgradePurchasePulse: boolean;
  readonly mHovAnimationSpeed: MHovAnimationSpeed;
  readonly mHovChargeDurationMs: MHovChargeDurationMs;
  readonly nHovAnimationSpeed: NHovAnimationSpeed;
  readonly nHovChargeDurationMs: NHovChargeDurationMs;
  readonly oHovChargeDurationMs: OHovChargeDurationMs;
  readonly outsideResetBurstAnimation: OutsideResetBurstAnimationMode;
}

export function resolveHoverIdleMotionPolicy(
  settings: HoverIdleSettingsState,
): HoverIdleMotionPolicy {
  const nonEssentialMotionEnabled = !settings.reduceMotion;

  return {
    hovCellHoverPulse: nonEssentialMotionEnabled,
    upgradePurchasePulse: nonEssentialMotionEnabled,
    mHovAnimationSpeed: nonEssentialMotionEnabled
      ? settings.mHovAnimationSpeed
      : "instant",
    mHovChargeDurationMs: settings.mHovChargeDurationMs,
    nHovAnimationSpeed: nonEssentialMotionEnabled
      ? settings.nHovAnimationSpeed
      : "instant",
    nHovChargeDurationMs: settings.nHovChargeDurationMs,
    oHovChargeDurationMs: settings.oHovChargeDurationMs,
    outsideResetBurstAnimation:
      nonEssentialMotionEnabled && settings.outsideResetBurstAnimationEnabled
        ? "full"
        : "off",
  };
}
